<!-- <div class="modal-header">
    <div class="modal-title">
        <label class="stype">{{type}}: </label><label class="svalue">{{typeValue}}</label>
    </div>
</div> -->
<div class="modal-body">
  <div class="card-custom">
    <table
      mat-table
      matSort
      #sortSource="matSort"
      [dataSource]="sourceDataMp"
      matSortDisableClear
      class="mat-elevation-z8 profiles-table"
    >
      <ng-container matColumnDef="name">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header="name"
          class="sticky-header"
        >
          {{constants.SOURCE_POP_UP.NAME}}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.name }}</td>
      </ng-container>

      <ng-container matColumnDef="id_type">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header="id_type"
          class="sticky-header"
        >
          {{constants.SOURCE_POP_UP.ID_TYPE}}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.id_type }}</td>
      </ng-container>

      <ng-container matColumnDef="id_value">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header="id_value"
          class="sticky-header"
        >
          {{constants.SOURCE_POP_UP.ID_VALUE}}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.id_value }}</td>
      </ng-container>

      <ng-container matColumnDef="expiry_date">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header="expiry_date"
          class="sticky-header"
        >
          {{constants.SOURCE_POP_UP.EXPIRE_DATE}}
        </th>
        <td mat-cell *matCellDef="let element">
          <label
            for=""
            [class]="isCurrentDateGreater(element.expiry_date) ? 'lbl-exp' : ''"
            >{{ element.expiry_date }}</label
          >
        </td>
      </ng-container>
       <ng-container matColumnDef="source">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header="source"
          class="sticky-header"
        >
          {{constants.SOURCE_POP_UP.SOURCE}}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.source }}</td>
      </ng-container>
      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns"
        class="sticky-header-row"
      ></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
  <div class="page-bottom">
    <mat-paginator
      #sourcePaginator
      [length]="totalItems"
      [pageSize]="pageSize"
      [pageSizeOptions]="[5, 10]"
      (page)="onPageChange($event)"
    >
    </mat-paginator>
    <button
      type="button"
      class="btn btn-sm btn-primary"
      (click)="activeModal.dismiss()"
    >
      Close
    </button>
  </div>
</div>
<!-- <div class="modal-footer">
</div> -->
